import { render } from "./BuyModal.vue?vue&type=template&id=f77f8826&scoped=true"
import script from "./BuyModal.vue?vue&type=script&lang=js"
export * from "./BuyModal.vue?vue&type=script&lang=js"

import "./BuyModal.vue?vue&type=style&index=0&id=f77f8826&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77f8826"]])

export default __exports__